export const PARAMETER_REGEXP = /([:*])(\w+)/g;
export const REPLACE_VARIABLE_REGEXP = "([^/]+)";
export const WILDCARD_REGEXP = /\*/g;
export const REPLACE_WILDCARD = "?(?:.*)";
export const NOT_SURE_REGEXP = /\/\?/g;
export const REPLACE_NOT_SURE = "/?([^/]+|)";
export const START_BY_SLASH_REGEXP = "(?:/^|^)";
export const MATCH_REGEXP_FLAGS = "";
